export const FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS =
  'externalGiftTable/FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS';
export const FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_SUCCESS =
  'externalGiftTable/FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_SUCCESS';
export const FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_FAILED =
  'externalGiftTable/FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_FAILED';

export const CHANGE_PRODUCTS_PAGE = 'externalGiftTable/CHANGE_PRODUCTS_PAGE';

export const FETCH_SHOPPING_CART = 'externalGiftTable/FETCH_SHOPPING_CART';
export const FETCH_SHOPPING_CART_SUCCESS =
  'externalGiftTable/FETCH_SHOPPING_CART_SUCCESS';
export const FETCH_SHOPPING_CART_FAILED =
  'externalGiftTable/FETCH_SHOPPING_CART_FAILED';

export const UPDATE_SHOPPING_CART = 'externalGiftTable/UPDATE_SHOPPING_CART';
export const UPDATE_SHOPPING_CART_SUCCESS =
  'externalGiftTable/UPDATE_SHOPPING_CART_SUCCESS';
export const UPDATE_SHOPPING_CART_FAILED =
  'externalGiftTable/UPDATE_SHOPPING_CART_FAILED';

export const SET_SHOPPING_CART_PRICES =
  'externalGiftTable/SET_SHOPPING_CART_PRICES';

export const ADD_SHOPPING_CART_PRODUCT =
  'externalGiftTable/ADD_SHOPPING_CART_PRODUCT';
export const REMOVE_SHOPPING_CART_PRODUCT =
  'externalGiftTable/REMOVE_SHOPPING_CART_PRODUCT';

export const CREATE_SHOPPING_CART = 'externalGiftTable/CREATE_SHOPPING_CART';
export const CREATE_SHOPPING_CART_SUCCESS =
  'externalGiftTable/CREATE_SHOPPING_CART_SUCCESS';
export const CREATE_SHOPPING_CART_FAILED =
  'externalGiftTable/CREATE_SHOPPING_CART_FAILED';

export const SET_TEMPORAL_PRODUCT_OF_NOT_LOGGED_USER =
  'externalGiftTable/SET_TEMPORAL_PRODUCT_OF_NOT_LOGGED_USER';
export const SET_LOGGED_AFTER_ADDING_TEMPORARY_PRODUCT =
  'externalGiftTable/SET_LOGGED_AFTER_ADDING_TEMPORARY_PRODUCT';

export const FETCH_GIFT_TABLE_INFO = 'externalGiftTable/FETCH_GIFT_TABLE';
export const FETCH_GIFT_TABLE_INFO_SUCCESS =
  'externalGiftTable/FETCH_GIFT_TABLE_INFO_SUCCESS';
export const FETCH_GIFT_TABLE_INFO_FAILED =
  'externalGiftTable/FETCH_GIFT_TABLE_INFO_FAILED';

export const SET_HAVE_A_SHOPPING_CART =
  'externalGiftTable/SET_HAVE_A_SHOPPING_CART';
export const SET_SHOPPING_CART_INFO =
  'externalGiftTable/SET_SHOPPING_CART_INFO';
export const RESET_EXTERNAL_GIFT_TABLE =
  'externalGiftTable/RESET_EXTERNAL_GIFT_TABLE';

export const UPDATE_CART_INFO = 'externalGiftTable/UPDATE_CART_INFO';
export const UPDATE_CART_INFO_SUCCESS =
  'externalGiftTable/UPDATE_CART_INFO_SUCCESS';
export const UPDATE_CART_INFO_FAILED =
  'externalGiftTable/UPDATE_CART_INFO_FAILED';
